import { Component, OnInit } from "@angular/core";
import { FileToUpload } from "../file-upload/file-to-upload.model";
import { ApiMethod } from "../apimethods/api-method";
import { GlobalConstants } from "../common/global-constants";
import { ArticleMonitorInfoModel } from "./articlemonitorinfo-model";
import * as ngswal from "sweetalert";
import { customfunctions } from "../common/customfunctions";
declare var $;

@Component({
  selector: 'app-articlemonitorinfo',
  templateUrl: './articlemonitorinfo.component.html',
  styleUrls: ['./articlemonitorinfo.component.css']
})
/** articlemonitorinfo component*/
export class ArticlemonitorinfoComponent {
  /** articlemonitorinfo ctor */
  static modelItem: ArticleMonitorInfoModel = new ArticleMonitorInfoModel();
  showInfoMetadataModal: boolean;
  static articleId: number;
  static aartId: number;
  static aproofId: number;
  static awebLink: string;
  static jrnlCode: string;
  static articleNo: string;
  static aactivity: string;
  showNotesModal: boolean;
  showFileUpload: boolean;
  showHoldModal: boolean;
  static showRelease: boolean;
  showHoldHistoryModal: boolean;
  showCorrectionModal: boolean;
  showReviewModal: boolean;
  showCorr: boolean;
  showOndemandFirstRelease: boolean;
  static holdType: string;
  isHold: boolean;
  fileBase64: string = "";
  fileToUpload: File = null;
  fileCount: number = 0;
  filePath: any;
  files: string[] = [];
  public lAuthorList: any;
  public lLogList: any;
  public lReviewMail: any;
  articleNotes: string;
  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        ArticlemonitorinfoComponent.modelItem = <ArticleMonitorInfoModel>data["MonitorPage"];
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  ngOnInit(): void {
    this.UpdateTableHeight();
    customfunctions.SetTodayDateValues("#Txt_DueDate");
    //setInterval(function () {
    //  if (ArticlemonitorinfoComponent.articleId != null) {
    //    ArticlemonitorinfoComponent.ArticleInfo(ArticlemonitorinfoComponent.articleId);
    //  }
    //}, 10000);
  }
  UpdateTableHeight() {
    $('#divWorkflow,#divFirstRelease,#divArticleLogList,#divArticleOldLogList').css('height', (GlobalConstants.size.height - 155));
  }
  showInfoPopUp(): void {
    ArticlemonitorinfoComponent.ArticleInfo(localStorage.aEID);
    this.showInfoMetadataModal = true;
  }
  hideInfoModal() {
    this.showInfoMetadataModal = false;
  }
  public static ArticleInfo(id): void {

    ArticlemonitorinfoComponent.articleId = id;
    var articleData = {
      ArticleId: id,
      LoginId: localStorage.aLoginID
    };

    ApiMethod.postMethod(ArticlemonitorinfoComponent.modelItem.articleInfoByNoApi, articleData).subscribe(
      result => {
        $('#divLoadData').css('height', GlobalConstants.size.height - 100);

        $('#tblWorkflow tbody tr').remove();
        $('#divWorkflow').css('height', GlobalConstants.size.height - 180);
        let itemWorkflow = result.aWorkflowList;
        let itemRound = 0;
        let itemPMApproval = 0;
        let itemPMCnt = 0;
        let itemPMCorr = 0;
        $.each(itemWorkflow, function (e, val) {
          if (val.Activity == "PM Approval") {
            itemPMApproval = itemPMApproval + 1;
          }
        });
        $.each(itemWorkflow, function (e, val) {
          if (val.Activity == "PM Approval") {
            itemPMCnt = itemPMCnt + 1;
          }
          if (val.Activity == "First Proof QC R1") {
            itemRound = itemRound + 1;
          }
          if (val.Activity == "PM Correction") {
            itemPMCorr = itemPMCorr + 1;
          }

          let trcolor = 'style="background-color:' + (val.Backcolor === 'Yes' ? 'lightblue' : 'white') + ';"';
          let tr = '<tr ' + trcolor + '>';
          tr += '<td>' + (e + 1) + '</td>';
          if (val.Activity == "First Proof QC R1") {
            tr += '<td>' + val.Activity.toString().replace('R1', 'R' + itemRound) + '</td>';
          }
          else if (val.Activity == "First Proof Correction R1") {
            tr += '<td>' + val.Activity.toString().replace('R1', 'R' + itemRound) + '</td>';
          }
          else if (val.Activity == "PM Approval" && val.ReopenDetails == "") {
            tr += '<td>' + val.Activity.toString() + ' R' + itemPMCnt + '</td>';
          }
          else if (val.Activity == "PM Approval" && val.ReopenDetails != "") {
            tr += '<td>' + val.Activity.toString() + ' R' + itemPMCnt + ' (' + val.ReopenDetails + ')' + '</td>';
          }
          else if (val.Activity == "PM Correction") {
            tr += '<td>' + val.Activity.toString() + ' R' + itemPMCorr + '</td>';
          }
          else if (val.Activity == "PM Correction Upload") {
            tr += '<td>' + val.Activity.toString() + ' R' + itemPMCorr + '</td>';
          }
          else {
            tr += '<td>' + val.Activity + '</td>';
          }
          tr += '<td>' + GlobalConstants.FormatDate(val.ScheduleDate) + '</td>';
          tr += '<td>' + GlobalConstants.FormatDate(val.RevisedScheduleDate) + '</td>';
          if ((val.EGOption == "FPPGPending" || val.EGOption == "ManualPGPending" || val.EGOption == "PCCorrectionPending" || val.EGOption == "FPQCPending" || val.EGOption == "FinalPGPending" || val.EGOption == "PCPending") && (val.AllocateUserID != localStorage.aLoginID)) {
            tr += '<td><span title="Allocated to user : ' + val.AllocateUserName + '">' + val.AllocateUserName + '</span></td>';
          }
          else {
            tr += '<td>' + GlobalConstants.FormatDate(val.CompletedDate) + '</td>';
          }

          var workflowaction = "";
          
          if (((val.ActivityID == 5) || (val.ActivityID == 21) || (val.ActivityID == 24)) && (val.Backcolor == 'Yes')) {
            
            workflowaction = '<span><i class="bx bx-reset ManualPaginationInitiate" style="font-size:18px; color:darkblue; " title="Revert to Previous Activity" data-artId="' + id + '" data-proofId="' + val.ProofingID + '" data-transId="' + val.ArtTransID + '" data-transStatus="' + val.TransStatus + '"  data-activity="' + val.ActivityID + '"></i></span>';
          }
          //else if (val.Backcolor == 'Yes') {
          //  workflowaction = '<span><i class="bx bx-reset Revert" style="font-size:18px; color:darkblue; " title="Revert to Previous Activity" data-artId="' + id + '" data-proofId="' + val.ProofingID + '" data-transId="' + val.ArtTransID + '" data-transStatus="' + val.TransStatus + '"  data-activity="' + val.Activity.toString() + '"></i></span>';
          //}
          else {
            workflowaction = workflowaction + '--';
          }
          tr += '<td class="dt-head-center">' + workflowaction + '</td>';
          tr += '</tr>';
          $('#tblWorkflow tbody').append(tr);
        });
        $('.ManualPaginationInitiate').click(function () {
          localStorage.aActivityId = $(this).attr('data-activity');
          ngswal({
            title: "Do you want to proceed to manual pagination?",
            text: "Article Manual Pagination Confirmation !",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false
          },
            function (isConfirm) {
              if (isConfirm) {

                ngswal({
                  title: 'Please wait processing!.....',
                  text: '',
                  showCancelButton: false,
                  showConfirmButton: false
                });

                $('#btnManualPagination').trigger("click");

              } else {
                ngswal("Cancelled", "You clicked cancel! :)", "warning");
              }
            });
        });

        $('.Revert').click(function () {
          ngswal({
            title: "Do you want to revert to previous activity?",
            text: "Article Revert Confirmation !",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false
          },
            function (isConfirm) {
              if (isConfirm) {

                ngswal({
                  title: 'Please wait processing!.....',
                  text: '',
                  showCancelButton: false,
                  showConfirmButton: false
                });


                $('#btnRevert').trigger("click");

              } else {
                ngswal("Cancelled", "You clicked cancel! :)", "warning");
              }
            });
        });

        $('#divLoading').hide(); $('#divArtInfo').show();

        $("#LoadingImagePopupInfo").hide();


      },
      error => {
        $("#LoadingImagePopupInfo").hide();

      }
    );
  }

  articleRevert() {
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID
    }
    ApiMethod.postMethod(ArticlemonitorinfoComponent.modelItem.articleRevertApi, aItemL).subscribe(
      result => {
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Updated !",
          text: result.message,
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );

  }

  articleManualPagination() {
    debugger;
    alert(localStorage.aActivityId);
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.aEID,
      ActivityId: localStorage.aActivityId
    }
    ApiMethod.postMethod(ArticlemonitorinfoComponent.modelItem.articleManualPaginationApi, aItemL).subscribe(
      result => {
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Updated !",
          text: result.message,
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );
  }


}
